import cjaAnalytics from 'yoda-core-components/lib/helpers/Analytics/CJAAnalytics';
import buildCJAPageViewPayload from 'yoda-core-components/lib/helpers/Analytics/CJAPageViewBuilder';
import AnalyticsActionTypes from 'yoda-site-components/lib/actionTypes/AnalyticsActionTypes';
import * as CouponPageActionTypes from '../actionTypes/CouponPageActionTypes';
import CouponActionFilter from '../analytics/CouponActionFilter';
import constants from '../analytics/Coupon.config';

const buildPageViewPayload = (state) => {
    const context = state.context || {};

    return buildCJAPageViewPayload({
        name: `${constants.COUPON_PAGE_ID}:${constants.COUPON_PAGE_NAME}`,
        type: constants.COUPON_PAGE_ID,
        siteSection: constants.siteSection.COUPON,
        category: {
            primary: constants.siteSection.COUPON,
        },
        flags: {
            isErrorPage: !!state.ErrorPage,
        },
        tech: {
            releaseVersion: context.__RELEASEVERSION__ || '',
            version: 'yoda coupon 1',
        },
    });
};

const buildCouponCJAPayload = (store, cjaEventName) => {
    const cjaCouponlData = CouponActionFilter.getCouponDL(store, cjaEventName);
    const couponInfo =
        (cjaCouponlData.cart &&
            cjaCouponlData.cart.couponRewardsInfo &&
            cjaCouponlData.cart.couponRewardsInfo[0]) ||
        {};
    return {
        event: cjaEventName,
        event_name: cjaEventName,
        couponApplyMethod: couponInfo.couponApplyMethod || '',
        couponCode: couponInfo.couponCode || '',
        couponEligible: couponInfo.couponEligible || '',
        couponType: couponInfo.couponType || '',
        couponDiscount: parseFloat(couponInfo.couponDiscount) || 0,
        couponAmount: parseFloat(couponInfo.couponAmount) || 0,
    };
};

const CJAMiddleware = (store) => (next) => (action) => {
    if (typeof window === 'undefined') return next(action);
    if (!cjaAnalytics.isEnabled()) return next(action);

    const state = store.getState();
    let eventName = null;
    let eventData = null;

    switch (action.type) {
        case CouponPageActionTypes.COUPON_PAGE_LOAD_READY:
            eventName = 'pageView';
            eventData = buildPageViewPayload(state);
            break;
        case AnalyticsActionTypes.UPDATE_ANALYTICS_CLICK_EVENT:
            eventName = 'coupon_applied';
            eventData = buildCouponCJAPayload(store, eventName);
            break;
        case AnalyticsActionTypes.REMOVE_ANALYTICS_CLICK_EVENT:
            eventName = 'coupon_removed';
            eventData = buildCouponCJAPayload(store, eventName);
            break;
        default:
            break;
    }

    if (eventName && eventData) {
        cjaAnalytics.track(eventName, eventData);
    }

    return next(action);
};

export default CJAMiddleware;
